import { render, staticRenderFns } from "./GeneralCreditRuleForm.vue?vue&type=template&id=0087aa5d&scoped=true"
import script from "./GeneralCreditRuleForm.vue?vue&type=script&lang=ts"
export * from "./GeneralCreditRuleForm.vue?vue&type=script&lang=ts"
import style0 from "./GeneralCreditRuleForm.vue?vue&type=style&index=0&id=0087aa5d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087aa5d",
  null
  
)

export default component.exports